import cn from 'classnames';

import { EColorMap } from '../constants/colorMap';
import { IConDefaultType } from '../types';

interface ILanguageIconProps extends IConDefaultType {}

function LanguageIcon({ color, className, size = 24, rotate, flip }: ILanguageIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z"
          fill={color || EColorMap.gray_0}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 12C2 11.4477 2.44772 11 3 11H21C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H3C2.44772 13 2 12.5523 2 12Z"
          fill={color || EColorMap.gray_0}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.9999 2C12.2807 2 12.5486 2.11808 12.7381 2.32538C15.1537 4.96847 16.5261 8.39955 16.5997 11.9794C16.6 11.9931 16.6 12.0069 16.5997 12.0206C16.5261 15.6004 15.1537 19.0315 12.7381 21.6746C12.5486 21.8819 12.2807 22 11.9999 22C11.7191 22 11.4512 21.8819 11.2617 21.6746C8.84615 19.0315 7.47371 15.6004 7.40011 12.0206C7.39983 12.0069 7.39983 11.9931 7.40011 11.9794C7.47371 8.39955 8.84615 4.96847 11.2617 2.32538C11.4512 2.11808 11.7191 2 11.9999 2ZM9.40013 12C9.46003 14.7019 10.3757 17.3047 11.9999 19.4406C13.6241 17.3047 14.5398 14.7019 14.5997 12C14.5398 9.29815 13.6241 6.69532 11.9999 4.55939C10.3757 6.69532 9.46003 9.29815 9.40013 12Z"
          fill={color || EColorMap.gray_0}
        />
      </svg>
    </i>
  );
}

export default LanguageIcon;
